var map = {
	"./ANDRE_NEVES.jpg": "e6c8",
	"./CLAUDIA_FERNANDES.jpeg": "9f3a",
	"./DANIEL_LEAL.jpeg": "6011",
	"./MANUEL ANTUNES.jpg": "39c6",
	"./PEDRO_MAGALHAES.jpg": "405f",
	"./RENATO_GOMES.jpeg": "ac85",
	"./RICARDO_BARBOSA.jpg": "e9c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4dd0";